/* eslint-disable import/prefer-default-export, no-unused-vars */

export enum EsgProgressBarViews {
  LIST = 'list',
  CALENDAR = 'calendar',
}
